export enum LevelDifficulties {
  easy,
  medium,
  hard,
}

export enum LevelTypes {
  station = "Stazione",
  bridge = "Ponte",
  roadSign = "Itinerario",
}

export interface ILevel {
  difficulty: LevelDifficulties;
  type: LevelTypes;
  name: string;
  fullImage: string;
  tiles: string[];
  successDialogContent: {
    subtitle: string;
    link: string;
    contents: {
      text: string;
      isBold: boolean;
    }[];
  };
}

export class Level implements ILevel {
  difficulty: LevelDifficulties;
  type: LevelTypes;
  name: string;
  fullImage: string;
  tiles: string[];
  successDialogContent: {
    subtitle: string;
    cta: string;
    link: string;
    contents: {
      text: string;
      isBold: boolean;
    }[];
  };
  size: number;
  maxTime: number;
  maxCorrectStartingTiles: number;

  constructor(obj: ILevel) {
    Object.assign(this, obj);

    switch (obj.difficulty) {
      case LevelDifficulties.easy:
        this.size = 4;
        this.maxTime = 40;
        this.maxCorrectStartingTiles = 3;
        break;
      case LevelDifficulties.medium:
        this.size = 5;
        this.maxTime = 60;
        this.maxCorrectStartingTiles = 4;
        break;
      case LevelDifficulties.hard:
        this.size = 6;
        this.maxTime = 80;
        this.maxCorrectStartingTiles = 6;
        break;
    }

    switch (obj.type) {
      case LevelTypes.bridge:
        this.successDialogContent.cta = "IL PONTE";
        break;
      case LevelTypes.station:
        this.successDialogContent.cta = "LA STAZIONE";
        break;
      case LevelTypes.roadSign:
        this.successDialogContent.cta = "L'ITINERARIO";
        break;
    }

    if (obj.name === "Terzo Valico") {
      this.successDialogContent.cta = "IL TERZO VALICO";
    } else if (obj.name === "Napoli - Bari") {
      this.successDialogContent.cta = "IL PROGETTO";
    }
  }
}
